/**
 * History
 *   08Jan2019 (SW)
 *    - ADO 15834: Operator logging into Handheld software
 */

import jwtDecode from "jwt-decode";
import qs from "qs";
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { FeatureService } from "../graycorp/feature.service";
ApiService.init(appConfig.VUE_APP_ROOT_API);

import storejs from "store";

import {
  TokenStorage,
  FeatureStorage,
  NavigationStorage,
  CompanyStorage,
  UserStorage,
  CommonStorage,
  secureStorage,
} from "../../../storage";
import { setValidNavigationLinks } from "../../../../_helpers/access-control";
import { TransactionListService } from "../../templates/transactions-list.services";
import { CacheService } from "../../../cache/cache-service";
import { SettingsService } from "../graycorp/settings.service";
import { ApplicationService } from "../../application/application.service";
import { LogInService } from "./login.service";

import DeviceIdManager from "../../../../_helpers/access-control/DeviceIdManager";

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", arguments);
}

class AuthenticationError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const UserService = {
  /**
   * Login the user and store the access token to TokenStorage.
   *
   * @returns access_token
   * @throws AuthenticationError
   * */
  async login(username, password) {
    const deviceManager = new DeviceIdManager();

    const deviceId = await deviceManager.getDeviceId();
    const isIncognito = await deviceManager.isIncognitoMode();

    const requestTokenData = {
      method: "post",
      url: "/Token",
      data: qs.stringify({
        client_id: appConfig.VUE_APP_CLIENT_ID,
        client_secret: appConfig.VUE_APP_CLIENT_SECRET,
        grant_type: "password",
        username: username,
        password: password,
        deviceFingerprint: {
          id: deviceId,
          isIncognito: isIncognito,
        },
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    };

    // const requestTenantData = {
    //   url: "api/ApplicationUserTenant",
    //   top: "100",
    //   select: "ApplicationTenantCode",
    // };

    // var loginResponse;

    await ApiService.customRequest(requestTokenData)
      .then(async (loginResponse) => {
        logDev(loginResponse);

        const tokenResponse = JSON.parse(loginResponse.request.response);
        // const tokenResponse = JSON.parse(loginResponse.data);

        logDev(tokenResponse);
        logDev(tokenResponse.access_token);

        TokenStorage.saveToken(tokenResponse.access_token);
        TokenStorage.saveRefreshToken(tokenResponse.refresh_token);
        TokenStorage.saveTenant(tokenResponse.tenant_id);
        TokenStorage.saveTenantUserCode(tokenResponse.username);
        TokenStorage.saveSessionId(tokenResponse.session_id);

        ApiService.setHeaders();

        // ApiService.setTokenHeader();
        // ApiService.setTenantHeader();
        // ApiService.setSessionHeader();

        await FeatureService.getFeatureData(tokenResponse.username)
          .then(async function (response) {
            let data = response.data.value;

            FeatureStorage.saveItems(data);

            await SettingsService.getBySettingName(
              "SalesOrderVersionInUse",
            ).then((res) => {
              let soVersion = "V1";

              if (res.data.value.length > 0) {
                soVersion = res.data.value[0].SettingValue;
              }

              FeatureStorage.saveSalesOrderVersionInUse(soVersion);
            });

            SettingsService.saveUseInSettingsValues([
              "PurchaseOrderVersionInUse",
              "StockTransferVersionInUse",
              "TouchSalesOrder",
              "SessionTimeOutInMinutes",
              "VersionCheckerReminderInMinutes",
              "VersionCheckerTimerInMinutes",
            ]);

            // Get API Version
            ApplicationService.getAPIVersion()
              .then((res) => {
                if (res.data) {
                  CommonStorage.saveItems(
                    "CUSTOMER_PREFIX_API_VERSION",
                    res.data,
                  );
                }
              })
              .catch((err) => {
                // eslint-disable-next-line no-console
                console.log("API Version Request Failed ", err);
              });

            var session_timeout = data.filter(
              (x) => x.SettingName == "SessionTimeOutInMinutes",
            );
            const broadcastChannel = new BroadcastChannel("session-channel");

            if ("serviceWorker" in navigator) {
              if (session_timeout) {
                broadcastChannel.postMessage({
                  action: "user_activity",
                  time_out: CommonStorage.getItems("SessionTimeOutInMinutes"),
                });
              }

              if (CommonStorage.getItems("VersionCheckerTimerInMinutes")) {
                broadcastChannel.postMessage({
                  action: "version_interval",
                  value:
                    CommonStorage.getItems("VersionCheckerTimerInMinutes") *
                    60 *
                    1000,
                });
              }
            }

            ApplicationService.getUIVersion(window.location.origin)
              .then((res) => {
                if (res && res.data) {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(res.data, "text/html");

                  // Find the meta tag with the name 'version'
                  const versionMetaTag = doc.querySelector(
                    'meta[name="version"]',
                  );

                  // Check if the meta tag is found
                  if (versionMetaTag) {
                    // Get the content attribute of the meta tag
                    const version = versionMetaTag.getAttribute("content");
                    CommonStorage.saveItems(
                      "CUSTOMER_PREFIX_UI_VERSION",
                      version,
                    );
                  }
                }
              })
              .catch((err) => {
                // eslint-disable-next-line no-console
                console.log("CX Version Request Failed ", err);
              });

            setValidNavigationLinks();

            await LogInService.getInitialData()
              .then(async (result) => {
                if (result.data) {
                  CompanyStorage.saveItems(
                    `companyName_${appConfig.VUE_APP_COOKIE_NAME}`,
                    result.data.CompanyName,
                  );

                  UserStorage.saveItems(
                    `UserFirstName_${appConfig.VUE_APP_COOKIE_NAME}`,
                    result.data.UserFirstName,
                  );

                  if (appConfig.VUE_APP_ENABLE_CACHE) {
                    await TransactionListService.getReportBackgroundScreens().then(
                      (backgroundReport) => {
                        CacheService.saveCache(
                          "ReportBackgroundScreens",
                          backgroundReport.data.value,
                          5,
                        );
                      },
                    );

                    await TransactionListService.getReportPreviewScreens().then(
                      (previewReport) => {
                        CacheService.saveCache(
                          "ReportPreviewScreens",
                          previewReport.data.value,
                          5,
                        );
                      },
                    );
                  }

                  secureStorage.set("isAdmin", result.data.IsAdmin);
                  secureStorage.set("roles", result.data.Roles);

                  return Promise.resolve(data);
                } else {
                  await ApiService.oDataGet({
                    url: "api/ApplicationUser",
                  }).then(async (result) => {
                    result.data.value[0].FirstName;
                    UserStorage.saveItems(
                      `UserFirstName_${appConfig.VUE_APP_COOKIE_NAME}`,
                      result.data.value[0].FirstName,
                    );

                    await TransactionListService.getReportBackgroundScreens().then(
                      (backgroundReport) => {
                        CacheService.saveCache(
                          "ReportBackgroundScreens",
                          backgroundReport.data.value,
                          5,
                        );
                      },
                    );

                    await TransactionListService.getReportPreviewScreens().then(
                      (previewReport) => {
                        CacheService.saveCache(
                          "ReportPreviewScreens",
                          previewReport.data.value,
                          5,
                        );
                      },
                    );
                  });

                  return Promise.resolve(data);
                }
              })
              .catch(function (error) {
                return Promise.error(error);
              });
          })
          .catch(function (error) {
            return Promise.error(error);
          });
        //   }
        // );
      })

      .catch(function (error) {
        // This error object contains more information than the previous one
        // that can be used to further improve the UX with proper error messages.
        return Promise.reject(error);
        // throw new AuthenticationError(error.status, error.data.Message);
      });
  },

  /**
   * Refresh the access token.
   * */
  async refreshToken() {
    // const refreshToken = TokenStorage.getRefreshToken();

    const requestData = {
      method: "post",
      url: "/Token",
      data: qs.stringify({
        client_id: appConfig.VUE_APP_CLIENT_ID,
        client_secret: appConfig.VUE_APP_CLIENT_SECRET,
        grant_type: "refresh_token",
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
      },
    };

    try {
      const response = await ApiService.login(requestData);
      const response2 = JSON.parse(response.request.response);
      TokenStorage.saveToken(response2.access_token);
      TokenStorage.saveRefreshToken(response2.refresh_token);
      ApiService.setTokenHeader();
      return response.data.access_token;
    } catch (error) {
      throw new AuthenticationError(
        error.response.status,
        error.response.data.detail,
      );
    }
  },

  getUsername() {
    const token = TokenStorage.getToken();
    if (!token) return "";
    var decoded = jwtDecode(token);
    return decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"];
  },

  /**
   * Logout the current user by removing the token from storage.
   *
   * Will also remove `Authorization Bearer <token>` header from future requests.
   * */
  logout() {
    // Remove the token and remove Authorization header from Api Service as well
    TokenStorage.clear();
    FeatureStorage.clear();
    NavigationStorage.clear();
    CompanyStorage.clear();
    ApiService.removeHeader();
    UserStorage.clear();
    CommonStorage.clearAll();

    storejs.clearAll();

    // NOTE: Again, we'll cover the 401 Interceptor a bit later.
    // ApiService.unmount401Interceptor()
  },
  async getUserByUsernameAndValidateCxUser(username) {
    const requestScreenData = {
      url: "api/Save_NewUser",
      top: "1",
      filter: `Code eq '${username}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getUserByUsername(username) {
    const requestScreenData = {
      url: "api/Users",
      top: "1",
      filter: `Username eq '${username}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  // TODO: evaluate the usage of this
  handleResponse(response) {
    return response.text().then((text) => {
      const data = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
          // auto logout if 401 response returned from api
          UserService.logout();
          location.reload(true);
        }

        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      return data;
    });
  },
  dataSourceConfig(params) {
    return ApiService.createDataSource(params.url, params);
  },
  async saveUser(isNewUser, user) {
    var payload = user;
    var url = "api/ApplicationUserManagement";

    if (isNewUser) return await ApiService.post(url, payload);
    // else
    //   return await ApiService.patch(
    //     url,
    //     customerAgent.CustomerCode,
    //     payload,
    //     "String"
    //   );
  },
  async saveLegacyCxUser(payload) {
    var url = "api/Save_NewUser";
    return await ApiService.post(url, payload);
  },
  async getUserTypes() {
    const requestScreenData = {
      url: "api/ApplicationUserType",
      select: ["Code", "DisplayName"],
      filter: `Inactive eq 'N'`,
      orderby: "Sequence asc, Code asc",
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getRoles(roleType) {
    const requestScreenData = {
      url: "api/Role",
      filter: `RoleType eq '${roleType}' and Inactive eq 'N'`,
      orderby: "RoleName asc",
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getRolesByLicenseType(licenseType) {
    return await ApiService.oDataGet({
      url: "api/Role",
      filter: `LicenseType eq '${licenseType}' and Inactive eq 'N'`,
      orderby: "RoleName asc",
    });
  },

  async getUserManagement(UserTypeCode, ApplicationUserCode) {
    const requestScreenData = {
      url: `api/ApplicationUserManagement(ApplicationUserCode='${ApplicationUserCode}',ApplicationUserTypeCode='${UserTypeCode}',UseExistingApplicationUserTypeCode='N')`,
      expand:
        "ApplicationUserManagementFeatures($expand=ApplicationUserManagementFeature($expand=ApplicationUserManagementFeatures($expand=ApplicationUserManagementFeature($expand=ApplicationUserManagementFeatures($expand=ApplicationUserManagementFeature)))))",
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getUserTypeCode(ApplicationUserCode) {
    const requestScreenData = {
      url: "api/ApplicationUserToApplicationTenant",
      select: ["ApplicationUserCode", "ApplicationUserTypeCode", "Inactive"],
      orderby: "ApplicationUserCode asc",
      top: "50",
      count: true,
      filter: `ApplicationUserCode eq '${ApplicationUserCode}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getUserTypeByCode(applicationUserCode) {
    const requestScreenData = {
      url: "api/ApplicationUserType",
      filter: `Code eq '${applicationUserCode}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getUserType() {
    const requestScreenData = {
      url: "api/ApplicationUser",
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async changeUserPassword(payload) {
    var url = "api/Save_UserPasswordChange";
    return await ApiService.post(url, payload);
  },

  async getUserRoles(userCode) {
    return await ApiService.get(`api/UserRole/${encodeURIComponent(userCode)}`);
  },

  async saveUserRoles(userCode, roleIds) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: `api/UserRole/${encodeURIComponent(userCode)}`,
      data: roleIds,
    });
  },
};

export { UserService, AuthenticationError };
